import { createRef, Component } from 'react';
import styled from 'styled-components';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { media } from '../../styles';
import StringUtils from '../../common/string-utils';

export default function withSearchResult(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.wrapperRef = createRef();

      this.state = {
        isFocused: false,
      };
    }

    componentDidUpdate() {
      if (this.props.isActive) {
        this.wrapperRef.current?.scrollIntoView({
          // scrolls only if element is about to go off viewable list
          block: 'nearest',
        });
      }
    }

    render() {
      const { onSelect, type, contentType, contentLabelOverrides, isExternal } = this.props;
      const typeToUse = isExternal ? contentType : type;
      const activeClass = this.props.isActive ? 'default-search-result--active' : '';
      // Show 'Guide' for SCORMs
      const searchResultType = typeToUse === AssetPickerTypes.SCORM ? AssetPickerTypes.GUIDE : typeToUse;

      return (
        <div
          ref={this.wrapperRef}
          className={`default-search-result ${activeClass}`}
          onClick={onSelect}
          {...(this.props.accessibilityProps
            ? {
                ...this.props.accessibilityProps,
                'aria-selected': this.state.isFocused,
                onFocus: () => this.setState({ isFocused: true }),
                onBlur: () => this.setState({ isFocused: false }),
              }
            : {})}
        >
          <div className="default-search-result--inner">
            <SearchResultContentWrapper>
              <SearchResultDetailsWrapper className="default-search-result--details">
                <WrappedComponent {...this.props} />
              </SearchResultDetailsWrapper>
              <SearchResultType className="default-search-result--type">
                <span>
                  {StringUtils.getLocalizedTypeFromReadableEnglishType(
                    searchResultType,
                    contentLabelOverrides,
                    Boolean(isExternal),
                  )}
                </span>
              </SearchResultType>
            </SearchResultContentWrapper>
          </div>
          <div className="default-search-result--mask" />
        </div>
      );
    }
  };
}

const SearchResultContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const SearchResultDetailsWrapper = styled.div`
  width: calc(100% - 90px);
  opacity: ${(props) => (props.dim ? 0.6 : 1)};
  display: flex;
  align-items: center;

  ${media.screenSmMax} {
    width: 100%;
  }
`;

const SearchResultType = styled.div`
  color: #848484;
  font-size: 0.8rem;
  white-space: nowrap;
  text-align: right;
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: 1px;
  height: calc(100% - 1px);
  background-color: white;
  padding: 0 10px;
  width: 80px;

  ${media.screenSmMax} {
    display: none;
  }

  span {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-size: 0.75rem;
  }
`;
